//import {encryptData} from './utils';
fourToldApp.controller("loginCntrl", function(conversation_history,cryptool, session, xmppAuth, theme, templates, esb, $scope, $localStorage, services, $window, $location, $rootScope, $httpParamSerializer, $cookieStore, $q, $mdToast, $mdDialog, countryCode, countries, $sce, $locale, countriesList) {
    $scope.showProcess = true
    if ($location.search().dataResult != null)
    {
        $scope.showProcess = true
    } else {
        $scope.showProcess = false
    }

    
    if($location.search().session)    
        $window.localStorage.removeItem("access_token1");

    if ($location.search().progress != null){
        $scope.initLoading = true;
    }else{
        $scope.initLoading = false;
    }
    $rootScope.loggedIn = false;
    $scope.loginError = undefined;
    $scope.remember = false;
    $scope.passwordVisibility = false;
    var userPhoto = {};
    var userData = {};
    var isDlgOpen;
    var isOPTlogin = false
    $scope.theme = theme.getTheme();
    $scope.catpchaVerified = false;
    $scope.captchaLoaded = true;   
    $scope.dni_types =  $scope.theme ? $scope.theme.docTypes : undefined;
    $scope.docType = $scope.dni_types && $scope.dni_types.length > 0 ? $scope.dni_types[0].id : undefined;
    $scope.showLogoHeader = true;
    $scope.loginWithID = false;
    $scope.agentMode = window.sessionStorage.getItem('mode') == 'asesorweb' ? true:false;
    countriesList.set(theme.getTheme())
    $scope.dial_codes = countriesList.get();
    if($scope.theme && $scope.theme.phone && $scope.theme.phone.hints){
        $scope.hints = $scope.theme.phone.hints;
    }
    var types = [{id: "PHONENUMBER", label:"Número de celular/teléfono", placeholder: "Número de teléfono"}]
    $scope.login_type = $scope.dni_types ? types.concat($scope.dni_types) : types.concat([{id: "ID", label:"Documento de identidad", placeholder: "Número de Documento"}]);
    window.sessionStorage.getItem('mode') == 'asesorweb' ? $scope.login_type.push({id: "OTP", label:"Código OTP", placeholder: "Documento de identidad"}) : undefined;
    $scope.cameraTour = function() { 
        $mdDialog.show({   
          locals: {
            isInit: true,
            isAudio: true,
            isVideo: true
           },    
          controller: 'cameraTourCntrl',
          templateUrl: './views/dashboard/cameraTour.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          fullscreen: true,
          escapeToClose: true 
        }).then(function(answer) {}, function() { 
        });
    };
    
    
      function cameraAudioPermission() {
        navigator.mediaDevices.getUserMedia({ audio: true, video:true }).then( ( stream ) => {
             stream.getTracks().forEach(track => {
                  track.stop();
             }); 
        },
        e => {
            if(e.message == "Permission denied")
                    $scope.cameraTour()
        })
      }
      cameraAudioPermission()
 
    if($window.navigator.userAgent.includes("CriOS")) {
        alert("Este navegador no está soportado en este dispositivo, le recomendamos usar Safari.");
    }

    window.localStorage.removeItem('UNLOCK');  
    if($scope.theme!=null && $scope.theme.captchaLogin!=null && $scope.theme.captchaLogin == true){
        $scope.showcaptcha = true;
    }
    else
        $scope.showcaptcha = false;
    $scope.language = services.language.getList({}, {}, function(response) {
        return response;
    });
    
    if (
         window.sessionStorage.getItem('identification') 
         || (window.sessionStorage.getItem('phoneNumber') && (window.sessionStorage.getItem("prefix"))
         || window.sessionStorage.getItem("documentType"))) {
        $scope.remember = true;
        $scope.username = window.sessionStorage.getItem('phoneNumber');
        $scope.dialCode = window.sessionStorage.getItem("prefix");
        $scope.docType = window.sessionStorage.getItem("documentType");
        $scope.login = $scope.login_type.find(element => element.id === window.sessionStorage.getItem('loginType'));
        if ($scope.docType) {
            $scope.loginWithID = true;
        }
        $scope.password = $window.sessionStorage.getItem("password");

    } else if($location.search().prefix!=null)
        $scope.dialCode = "+" + $location.search().prefix;
    else {
        countryCode.dialCode(false, theme.getTheme())
        .then(function (result) {
            $scope.progressCircular = $scope.initLoading;
            $scope.dialCode = result;
        })
        .catch(function (message) {
            $scope.progressCircular = false;
            $scope.dialCode = countries.countries[0].dial_code;
            $scope.showAlert('Debe activar los permisos de ubicación');
        });
    };
    if(!$scope.dialCode || $scope.dialCode == "undefined" ) {
        $scope.dialCode = "+51"
    }

    $scope.logoutForced = function(loginFunction) {
        $window.localStorage.removeItem("access_token1");
        $window.sessionStorage.removeItem("user_teller_agent");
        services.closeSession($scope.tokenLogOut).request({}, {}, function(response, event) { 
            
        services.logout($scope.tokenLogOut).post({}, {}, function(response) {
                xmppAuth.Chat.disconnect();
                loginFunction()
            });
        });
    };

    $scope.logoutLogin = function() {
        $window.localStorage.removeItem("access_token1");
        $window.sessionStorage.removeItem("user_teller_agent");
        services.closeSession($scope.tokenLogOut).request({}, {}, function(response, event) {
            $scope.showAlert("La sesión de usuario ha sido cerrada exitosamente.");
            
        services.logout($scope.tokenLogOut).post({}, {}, function(response) {
                xmppAuth.Chat.disconnect();
            });
        });
    };
    $scope.submit = function(fromRegister, isValid, isByDocId) {
        
        if($location.search().identification) {
            $window.sessionStorage.setItem("identification", $location.search().identification)  
            isByDocId = true
        }


        if(isByDocId) {
            $scope.loginWithID = true
            $scope.docType = "ANY"
            $scope.username = $window.sessionStorage.getItem("identification")
        }
            

        if($location.search().tag!=null && $location.search().tag!='undefined') {
            var tag = $location.search().tag
            $scope.submitTag(fromRegister, tag.toUpperCase())
        }
        else if ($scope.username && $scope.password && isValid) {
            var numeroTelf = $scope.dialCode + $scope.username.toString();
            var data = {userName: numeroTelf}
            services.userTags().getTags(data,
                function(response) {
                    $scope.progressCircular = undefined
                    var tags = response.data;
                    if(tags.length == 0) {
                        $scope.submitTag(fromRegister)
                    } else if(tags.length == 1) {
                        var tag = tags[0]
                        $scope.submitTag(fromRegister, tag.id)
                    } else {
                        $scope.progressCircular = undefined;
                        $scope.dialogTag(tags, fromRegister)
                    }
                    
                },
                function error(response) {console.log("error getTag")});
        }
    }

    
    $scope.rememberMe = function() {
        if($scope.remember){
            window.sessionStorage.setItem('phoneNumber', $scope.username);
            window.sessionStorage.setItem("prefix", $scope.dialCode);
            if ($scope.login){
                window.sessionStorage.setItem("loginType", $scope.login.id);
            }
        } else{
          window.sessionStorage.removeItem('phoneNumber');
          window.sessionStorage.removeItem("prefix");
          window.sessionStorage.removeItem("loginType");
        }
    };
    
    $scope.buildUserName = function(number, tag, loginWithID, loginWithOTP, typeDoc) {
        var userName = number;
        if (tag) {
            userName = userName + "|" + tag;
        } else {
            userName = userName + "|";
        }
        if (loginWithID) {
            userName = userName + "|I=" + typeDoc;
        } else if (loginWithOTP) {
            userName = userName + "|O";
        } else {
            userName = userName + "|P";
        }
    
        return userName;
    };

    $scope.noRememberIDType = function() {
        if($scope.remember && $scope.loginWithID && $scope.docType && $scope.docType != null && $scope.docType != 'null') {
            window.sessionStorage.setItem("documentType", $scope.docType);
            window.sessionStorage.setItem("loginWithID", $scope.loginWithID);
          } else {
            window.sessionStorage.removeItem("documentType");
            window.sessionStorage.removeItem("loginWithID");
          }
    };
    
    $scope.submitTag = function(fromRegister, tag) {
        $window.sessionStorage.setItem('registerTag', tag)
        if ($scope.username && $scope.password) {
            if(!$scope.loginWithID && $scope.theme!=null && $scope.theme.phone!=null && $scope.theme.phone.regex!=null){
                var re = new RegExp($scope.theme.phone.regex);
                if(!re.test($scope.username)){
                    $scope.dialog($scope.hints, "error-toast");
                    return;
                }
             
            }
            let telf = $scope.docType === "OTP" ? $scope.username.toString() : $scope.dialCode + $scope.username.toString();
            var numeroTelf =  !$scope.loginWithID ? telf : $scope.username.toString();
            $scope.rememberMe();
            $scope.noRememberIDType();


            numeroTelf = $scope.buildUserName(numeroTelf, tag, $scope.loginWithID, $scope.docType === "OTP", $scope.docType);

            if(!$scope.catpchaVerified &&($scope.theme!=null && $scope.theme.captchaLogin!=null && $scope.theme.captchaLogin == true)) {
                if(!fromRegister){                   
                    return;
                }
            }
            var data = $httpParamSerializer({
                grant_type: "password",
                username: numeroTelf,
                password: $scope.password
            });
            $scope.progressCircular = true;
            var token = 'Basic ' + window.btoa("4told-fin-api:secret");
            services.login(token).login({}, data, function(response) {
                $('#main-content').removeClass('merge-left');
                var now = new $window.Date(),
                    exp = new $window.Date(now.getFullYear(), now.getMonth() + 6, now.getDate());
                $scope.tokenLogOut = 'bearer ' + response.access_token;
                
                if (response.access_token) {
                    $localStorage.$reset();
                    templates.template();

                    userPhoto = services.user.userServices('bearer ' + response.access_token).userPhoto({}, function(response) {
                        services.user.setPhoto(response.data);
                    }, function error(response) {
                        console.log("error user photo");
                    });

                    tag = services.tag('bearer ' + response.access_token).theme({}, function(response) {
                        if(response.data[0] && response.data[0].properties[0]!== undefined){
                            $window.sessionStorage.setItem("theme",response.data[0].properties[0].field4);
                         } else{
                            $window.sessionStorage.removeItem("theme");
                         }
                      }, function error(response) {
                          console.log("error tag");
                    });

                    channel = services.channel('bearer ' + response.access_token).alternatechannels({}, function(response) {
                        var channel = [] = response.data;
                        response.data.forEach(element => element.unread = 0);
                        $localStorage.channel = channel;
                      }, function error(response) {
                        console.log("Error in service Channel");
                    });
                    userData = services.user.userServices('bearer ' + response.access_token).userData({}, function(response) {
                        if (response.data) {
                            var permissions = new Array();
                             var rolesToUser = response.data.userInfo.rolesToUser;
                             for(var roleToUser of rolesToUser) {
                                var role = roleToUser.role;
                                var rolesToPermission = role.rolesToPermission;
                                for(var roleToPermission of rolesToPermission) {
                                    var permission = roleToPermission.permission;
                                    permissions.unshift(permission.code);
                                    if( permission.code == "SCN_BASIC_GROUPS" || permission.code == "SCN_ADMIN_GROUPS") {
                                        response.data.userInfo.hasGroupPermissions = true;
                                        if(permission.code == "SCN_ADMIN_GROUPS") {
                                            response.data.userInfo.hasGroupAdminPermissions = true;
                                        }
                                    }
                                }
                             }

                            response.data.userInfo.permissions = permissions;
                            services.user.setData(response.data.userInfo);

                            $window.sessionStorage.setItem('requiredPasswordChange', response.data.userInfo.requiredPasswordChange);
                            
                            if(response.data.userInfo.properties && response.data.userInfo.properties._openfireContactServer) {
                                $window.sessionStorage.setItem("openfireContactServer",cryptool.encryptData(response.data.userInfo.properties._openfireContactServer + "@" + userData.data.userInfo.xmppConfig.serviceName));
                            } else {
                                $window.sessionStorage.setItem("openfireContactServer",cryptool.encryptData("aga.dev@" + response.data.userInfo.xmppConfig.serviceName)); 
                            }
                            
                        }
                    }, function(error) {
                        if(error && error.status === 503 && error.data && error.data.code === -503) {
                            $scope.loginError = undefined;
                            $window.localStorage.removeItem("access_token1");
                            $scope.showAlert("Acceso denegado", "El sistema no está disponible en estos momentos");
                        }
                        console.log("error user data ", error);
                    });
                    $q.all([
                        userData.$promise,
                        userPhoto.$promise,
                        tag.$promise
                    ]).then(function() {
                        if (userData.data) {
                            window.top.postMessage({type:'login', token: response.access_token}, '*');
                            $window.sessionStorage.setItem( "userXmpp", userData.data.userInfo.xmppConfig.username);
                            $window.sessionStorage.setItem( "passwordXmpp", cryptool.encryptData(userData.data.userInfo.xmppConfig.password));
                            $window.sessionStorage.setItem("serviceName", cryptool.encryptData(userData.data.userInfo.xmppConfig.serviceName));
                            $window.sessionStorage.setItem("host", cryptool.encryptData(userData.data.userInfo.xmppConfig.host));

                            services.conversation_history('bearer ' + response.access_token).request({
                                start: 0,
                                maxRows: 60
                            }, {}, function(response2) {
                                $window.sessionStorage.setItem('conversationsCount', response2.conversationsCount);
                                $window.sessionStorage.setItem('originalPageCount', parseInt($window.sessionStorage.getItem('originalPageCount') || 0) + response2.conversations.length);
                                conversation_history.setChatData(response2, [], 'login', null);
                                var userDataXmpp = userData.data.userInfo.xmppConfig;


                                if($location.search().offline) {
                                    $scope.closeToast();
                                    $window.localStorage.setItem("access_token1", response.access_token, {
                                        expires: exp
                                    });
                                    $cookieStore.put("refresh_token", response.refresh_token, {
                                        expires: exp
                                    });
                                    var user =  services.user.getData();
                                    saveUrlTag();
                                    if(userData.data.sessionTimeOutMin!=null){
                                        $localStorage.sessionTimeOutMin = userData.data.sessionTimeOutMin * 60;
                                    } 
                                    $locale.NUMBER_FORMATS.DECIMAL_SEP =  ".";
                                    $locale.NUMBER_FORMATS.GROUP_SEP =  ",";
                                    $localStorage.decimalSeparator =  ",";
                                    $localStorage.groupSeparator =  ".";
                                    if(userData.data.decimalSeparator) {
                                       // $locale.NUMBER_FORMATS.DECIMAL_SEP = userData.data.decimalSeparator;
                                        $localStorage.decimalSeparator = userData.data.decimalSeparator;
                                    }
                                    if(userData.data.groupSeparator) {
                                       // $locale.NUMBER_FORMATS.GROUP_SEP = userData.data.groupSeparator;
                                        $localStorage.groupSeparator = userData.data.groupSeparator;
                                    }
                                     
    
                                    if($location.search().tag!=null && $location.search().tag!='undefined' && $location.search().user_teller_agent!=null
                                    && $location.search().user_teller_agent!='undefined' && ($window.navigator.userAgent=== 'commerce-mobile' || ($location.search().mode!=null && $location.search().mode === 'asesorweb') )){
    
                                        if($window.navigator.userAgent=== 'commerce-mobile')
                                            $window.sessionStorage.setItem('isAgentWebView', true);
    
                                        $location.search('password', null)
                                        $location.search('prefix', null)
                                        $location.search('phoneNumber', null)
                                        $window.sessionStorage.setItem('sessionType', 'EMBEDDED_AGENT');
    
                                    }
                                    else{
                                        $window.sessionStorage.setItem('isAgentWebView', false);
                                        $window.sessionStorage.setItem('sessionType', 'BORROWER');
                                    }
                                        
    
                                    if(user.requiredPasswordChange && !$scope.agentMode && $window.sessionStorage.getItem('isAgentWebView') === "false")
                                        $location.path("/change-password");
                                    else if(userData.data.userInfo.needConfigureQuestions === true)
                                        {
                                            if($window.sessionStorage.getItem('isAgentWebView') === "true"){
                                                    $window.sessionStorage.setItem('needConfigureQuestions', false);
                                                    $location.path("/dashboard");
                                            }
                                            else {
                                                if(userData.data.userInfo.activatedConfigureQuestions === true) {
                                                    $window.sessionStorage.setItem('needConfigureQuestions', true);
                                                    $window.sessionStorage.setItem('activatedConfigureQuestions', true);
                                                    $window.localStorage.removeItem("dataQuentions");
                                                    $location.path("/quentions");
                                                } else {
                                                    $window.sessionStorage.setItem('activatedConfigureQuestions', false);
                                                    $window.sessionStorage.setItem('needConfigureQuestions', false);
                                                    $location.path("/dashboard");
                                                }
                                            }
    
                                        }
                                        else{
                                            $window.sessionStorage.setItem('needConfigureQuestions', false);
                                            $location.path("/dashboard");
                                        }    
                                    }


                                //xmppAuth.Chat.disconnect();
                                if(!$location.search().offline) 
                                    xmppAuth.Chat.connect(userDataXmpp.username + "@" + userDataXmpp.serviceName, userDataXmpp.password);
                            });



                            $localStorage.identification_channel =  {
                                "alternateChannelId": null,
                                "alternateChannel" : null
                            }
                             
                                $scope.$on("iconConnected", function(event, data) {
                                    if (data && data === "CONNECTED") {
                                        $scope.closeToast();
                                        $window.localStorage.setItem("access_token1", response.access_token, {
                                            expires: exp
                                        });
                                        $cookieStore.put("refresh_token", response.refresh_token, {
                                            expires: exp
                                        });
                                        var user =  services.user.getData();
                                        saveUrlTag();
                                        if(userData.data.sessionTimeOutMin!=null){
                                            $localStorage.sessionTimeOutMin = userData.data.sessionTimeOutMin * 60;
                                        } 
                                        $locale.NUMBER_FORMATS.DECIMAL_SEP =  ".";
                                        $locale.NUMBER_FORMATS.GROUP_SEP =  ",";
                                        if(userData.data.decimalSeparator) { 
                                           window.localStorage.setItem("decimalSeparator", userData.data.decimalSeparator);
                                             
                                        }
                                        if(userData.data.groupSeparator) { 
                                            window.localStorage.setItem("groupSeparator", userData.data.groupSeparator);
                                            
                                        }
                                        
                                      
    
                                        if($location.search().tag!=null && $location.search().tag!='undefined' && $location.search().user_teller_agent!=null
                                        && $location.search().user_teller_agent!='undefined' && ($window.navigator.userAgent=== 'commerce-mobile' || ($location.search().mode!=null && $location.search().mode === 'asesorweb') )){
    
                                            if($window.navigator.userAgent=== 'commerce-mobile')
                                                $window.sessionStorage.setItem('isAgentWebView', true);
    
                                            $location.search('password', null)
                                            $location.search('prefix', null)
                                            $location.search('phoneNumber', null)
                                            $window.sessionStorage.setItem('sessionType', 'EMBEDDED_AGENT');
    
                                        }
                                        else{
                                            $window.sessionStorage.setItem('isAgentWebView', false);
                                            $window.sessionStorage.setItem('sessionType', 'BORROWER');
                                        }
                                            
    
                                        if(user.requiredPasswordChange && !$scope.agentMode && $window.sessionStorage.getItem('isAgentWebView') === "false")
                                            $location.path("/change-password");
                                        else if(userData.data.userInfo.needConfigureQuestions === true)
                                            {
                                                if($window.sessionStorage.getItem('isAgentWebView') === "true"){
                                                        $window.sessionStorage.setItem('needConfigureQuestions', false);
                                                        $location.path("/dashboard");
                                                }
                                                else {
                                                    if(userData.data.userInfo.activatedConfigureQuestions === true) {
                                                        $window.sessionStorage.setItem('needConfigureQuestions', true);
                                                        $window.sessionStorage.setItem('activatedConfigureQuestions', true);
                                                        $window.localStorage.removeItem("dataQuentions");
                                                        $location.path("/quentions");
                                                    } else {
                                                        $window.sessionStorage.setItem('activatedConfigureQuestions', false);
                                                        $window.sessionStorage.setItem('needConfigureQuestions', false);
                                                        $location.path("/dashboard");
                                                    }
                                                }
    
                                            }
                                            else{
                                                $window.sessionStorage.setItem('needConfigureQuestions', false);
                                                $location.path("/dashboard");
                                            }
    
                                    }
                                })
                          

                        } else if (userData.code == -403) {
                            $scope.loginError = undefined;
                            $window.localStorage.removeItem("access_token1");
                            if(!isOPTlogin)    
                                $scope.deleteData("Acceso denegado", "Le invitamos a ponerse en contacto con soporte técnico para mayor información");
                        } else if (userData.code == -503) {
                            $scope.loginError = undefined;
                            $window.localStorage.removeItem("access_token1");
                            $scope.deleteData("Acceso denegado", "El sistema no está disponible en estos momentos");
                        } else if (userData.code == -74 && userData !== null) {
                            $scope.loginError = undefined;
                            $scope.sessionExist("Acceso denegado", "La sesión de usuario ya existe. Por seguridad la sesión será cerrada.");
                        }
                    }, function(error) {
                        $window.localStorage.removeItem("access_token1");
                        if (services.user.getPhoto()) {
                            $window.localStorage.removeItem("userPhoto")
                        }
                        if (services.user.getLogo()) {
                            $window.localStorage.removeItem("userLogo")
                        }
                        if (services.user.getData()) {
                            $window.localStorage.removeItem("userData")
                        }
                    })
                } else {
                        var messageError = "Usuario o contraseña inválidos";
                        $scope.loginError = undefined
                    if(response.code){
                        switch (response.code){
                            case 400:
                                messageError = "Usuario o contraseña inválidos";
                                $scope.loginError = true;
                                $scope.dialog(messageError, "error-toast");
                                resetCaptcha();
                            break;
                            case -203:
                                messageError = "El usuario ha sido bloqueado";
                                window.localStorage.setItem("UNLOCK", "UNLOCK")
                                $scope.showConfirmToUnlock(messageError)
                                
                                resetCaptcha();
                            break;
                            case -223:
                                messageError = "Esta IP ha sido bloqueada";
                                window.localStorage.setItem("UNLOCK", "UNLOCK")
                                $scope.showConfirmToUnlock(messageError)
                               
                                resetCaptcha();
                            break;
                            default:
                                messageError = "Ocurrio un error, intente de nuevo";
                                $scope.dialog(messageError, "error-toast");
                                resetCaptcha();
                             }

                            
                        }

                                    
                   
                }
            }, function(error) {
                $scope.dialog("Ocurrio un error, intente de nuevo", "error-toast");
                $scope.loginError = undefined
            })
        }
    };

    if (window.sessionStorage.getItem('phoneNumber')) {
        $scope.remember = true;
        $scope.username =  window.sessionStorage.getItem('phoneNumber'); 
    } 

    if(
        ($window.navigator.userAgent=== 'commerce-mobile' || $location.search().mode!=null && $location.search().mode =='asesorweb') &&
        $location.search().tag!=null && 
        !$location.search().session && 
        $location.search().tag!='undefined' && 
        $location.search().user_teller_agent!=null && 
        $location.search().user_teller_agent!='undefined' && 
        !$location.search().newSession && 
        $location.search().phoneNumber!=null && 
        $location.search().prefix!=null) {
        
        if($window.navigator.userAgent=== 'commerce-mobile')
            $scope.showLogoHeader = false;
        else
            $scope.showLogoHeader = true;

        $window.sessionStorage.setItem("identification", $location.search().identification)
        $scope.username =  $location.search().phoneNumber;
        $scope.dialCode = "+" + $location.search().prefix;
        if($location.search().password!=null){
           $scope.password =$location.search().password;
           $scope.submit();
        }
        else if($location.search().mode!=null && $location.search().mode =='asesorweb' && $location.search().session == null){
            try{
                $scope.password = $location.search().phoneNumber.substring($location.search().phoneNumber.length  - 5);                 
                let token = $window.localStorage.getItem("access_token1")  
                session.logout(true);  
                window.top.postMessage('success-logout', '*')
                if(!$scope.password) return;
                window.localStorage.removeItem('ngStorage-msg')            
                if(token) {
                    services.closeSession(token).request({}, {}, function(response, event) {
                        console.log("services.closeSession") 
                        console.log("token " + token)     
                    services.logout(token).post({}, {}, function(response) {
                            xmppAuth.Chat.disconnectAll(); 
                            console.log("services.logout")
                            console.log("session.logout()")                            
                        });
                    });
                } else {
                    if(!$scope.password) return;
                    $scope.submit()
                }

               ;
            }catch(err){
                console.error("Error autologin." + err);
            }                        
        }

    } else if(
        ($window.navigator.userAgent === 'commerce-mobile' || $location.search().mode!=null && $location.search().mode =='asesorweb') &&  
        $location.search().identification!=null) {

        if($window.navigator.userAgent=== 'commerce-mobile')
            $scope.showLogoHeader = false;
        else
            $scope.showLogoHeader = true;
        
        $window.sessionStorage.setItem("identification", $location.search().identification)
        $scope.username = $location.search().identification;
        if($location.search().password != null) {
           $scope.password = $location.search().password;
           $scope.submit(false, false, true);
        }
    }
    
    $scope.deleteData = function(msg, title) {
        $scope.loginError = undefined;
        $scope.showAlert(msg, title)
    };
    $scope.sessionExist = function(msg, title) {
        $scope.loginError = undefined;
        $scope.showAlertExist(msg, title)
    };
    
    $scope.showAlertExist = function(msg, title) {
        $scope.progressCircular = undefined;
        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("#popupContainer"))).title(msg).clickOutsideToClose(false).textContent(title).ariaLabel("Alert Dialog Demo").ok("Ok"))
               .finally(function() {
                $scope.logoutLogin();                            
          });
    };

    $scope.showConfirmToUnlock = function (message) {
        var confirm = $mdDialog.confirm()
          .title('')
          .textContent(message)
          .ok('Desbloquear')
          .cancel("Cancelar");

        $mdDialog.show(confirm).then(function (answer) {
          if(answer) {
            $location.path('/forgot-password');
          } else {
            $mdDialog.cancel();
          }
        });
      };
    
    $scope.dialog = function(message, type) {
        $scope.progressCircular = undefined;
        $mdToast.show(
            $mdToast.simple()
            .textContent(message)
            .position('top')
            .action('Ok')
            .theme(type)
            .hideDelay(0)
        ).then(function(answer) {
            if(answer === "ok")
              $scope.loginError = false;
          });
    };

    $scope.closeToast = function() {
        if (isDlgOpen) return;
        $mdToast
            .hide()
            .then(function() {
                isDlgOpen = false;
            });
    };

    $scope.showAlert = function(msg, title) {
        $scope.progressCircular = undefined;
        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("#popupContainer"))).title(msg).clickOutsideToClose(false).textContent(title).ariaLabel("Alert Dialog Demo").ok("Ok"))
    };



    $scope.dialogTag = function(data, fromRegister) {
        $scope.progressCircular = false;
        $mdDialog.show({
                controller: DialogController,
                locals: {
                    items: data
                },
                templateUrl: '../views/pages/tags.html',
                parent: angular.element(document.body)
            })
            .then(function(tag) {
                if (tag) {
                    $scope.progressCircular = true;
                    $scope.submitTag(fromRegister, tag)
                }
            }, function(cancel) {});
    };

    $scope.dialogLanguage = function(data, ev) {
        $mdDialog.show({
                controller: DialogController,
                locals: {
                    items: data
                },
                templateUrl: '../views/pages/language.html',
                parent: angular.element(document.body),
                targetEvent: ev,
            })
            .then(function(answer) {
                if (answer) {
                    $scope.progressCircular = true;
                    $window.sessionStorage.setItem("lang", answer);
                    let params = {};
                    if ($location.search().tag){
                        params.code = $location.search().tag;
                        params.lang = answer;
                    } else if($scope.theme){
                        params.code = $scope.theme.tag;
                        params.lang = answer;
                    } else params.lang = answer;
                    services.language.setLanguage(params, {}, function(response) {
                        $window.sessionStorage.setItem("urlTerms", response.data.url)
                        $location.path('/terms');
                    }, function err() {});
                }
            }, function(cancel) {});
    };

    function DialogController($scope, $mdDialog, items) {
        $scope.items = items;
        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.answer = function(answer) {
            $mdDialog.hide(answer);
        };
    };
    $scope.languageAssignment = function(ev) {
        let answer;
        if ($location.search().lang){
            answer = $location.search().lang;
        }else if(theme.getTheme() && theme.getTheme().lang){
            answer = theme.getTheme().lang;
        }
        if(answer){
            $window.sessionStorage.setItem("lang", answer);
            let params = {};
            if ($location.search().tag){
                params.code = $location.search().tag;
                params.lang = answer;
            } else if($scope.theme){
                params.code = $scope.theme.tag;
                params.lang = answer;
            } else params.lang = answer;
            services.language.setLanguage(params, {}, function(response) {
                $window.sessionStorage.setItem("urlTerms", response.data.url)
                $location.path('/terms');
            }, function err() {});
            return;
        }
        $scope.progressCircular = true;
        $q.all([
            $scope.language.$promise
        ]).then(function() {
            $scope.progressCircular = false;
            $scope.dialogLanguage($scope.language, ev);
        });
    };
    $scope.forgotPassword = function(ev) {
        window.localStorage.removeItem('UNLOCK'); 
        $location.path('/forgot-password');
    };
    $scope.deleteUser = function(ev) {
        if(esb !== 'https://esb.holaprestamo.com.co')        
             $location.path('/delete-user');
    }

    $scope.visibility = function() {
        var x = document.getElementById("password");
        if (x.type === "password") {
            x.type = "text";
            $scope.passwordVisibility = true;
        } else {
            x.type = "password";
            $scope.passwordVisibility = false;
        }
    }

 

      $scope.verifyCatpcha = function(response){
            if(response!=null)
                $scope.catpchaVerified = true;
        

      }

      $scope.captchaErrorCallback = function(response){
            if($scope.theme!=null && $scope.theme.captchaLogin!=null && $scope.theme.captchaLogin == true){
                console.log("Error cargando captcha");
            }
            
      }

      $scope.captchaExpiredCallback = function(response){
        console.log("Captcha expirado");
        $scope.catpchaVerified = false;
  }
  $scope.parseToUrl = function(search){
    return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')

}


    saveUrlTag = function(){
        var urlTag =  $location.url();
        var indexTag = urlTag.indexOf("?tag=");   
        if(indexTag>0){       
                
            var url = urlTag.substring(indexTag, urlTag.lenght);
            if(url.includes("password=")) { 
                var jsonUrl = $scope.parseToUrl(url);                
                url = url.replace("password=" + jsonUrl.password, '');           }

            if(url.includes("phoneNumber="))
            {
                url = url.substring(url.indexOf("phoneNumber="), 0)                
            }


            $window.sessionStorage.setItem("urlTag", url);
        }else
        {
            $window.sessionStorage.setItem("urlTag", "");
        }
    };  

    
$scope.renderHtml = function (htmlCode) {
    return $sce.trustAsHtml(htmlCode);
  };


    $scope.set_data_login = function(data){
        delete $scope.messageCodeOTP; 
        delete $scope.password;
        delete $scope.errorForm;
        $scope.remember ? window.sessionStorage.setItem("loginType", $scope.login.id)  : window.sessionStorage.removeItem("loginType", $scope.login.id)        
        if(!data.placeholder)
            data.placeholder = "Número de documento";
        switch(data.id) {
            case "PHONENUMBER":
                countriesList.set(theme.getTheme())
                $scope.dial_codes = countriesList.get();
                $scope.loginWithID = false;
                if($scope.dial_codes.countries.length === 1 ){
                    var styleElem = document.head.appendChild(document.createElement("style"));
                    var content = document.head.appendChild(document.createElement("style"));
                    styleElem.innerHTML = ".left-addon-user input {padding-left:  60px; }";
                    content.innerHTML = '.left-addon-user .fa:after {content: " ' +$scope.dialCode+ ' ";  font-size: 14px; color: #555; font-family: Roboto, "Helvetica Neue", sans-serif;}';
                }
                break;
            case "ID":
                $scope.docType = "ANY";
                $scope.loginWithID = true;
                break;
            case null:
                    delete $scope.username;
                    delete $scope.password;  
                break;
            default:
                $scope.docType = data.id;
                $scope.loginWithID = true;
        }
        if(data.id !== "PHONENUMBER")
            setCssStyle();
    };
    function setCssStyle(){
        var styleElem = document.head.appendChild(document.createElement("style"));
        var content = document.head.appendChild(document.createElement("style"));
        styleElem.innerHTML = ".left-addon-user input {padding-left:  30px; };";
        content.innerHTML = ".left-addon-user .fa:after {content: '';}";    
    };
    setCssStyle();
    var downloadTimer;
    function countdown() {
        var minutes = '01';
        var seconds = 59;
        function tick() {
            var counter = document.getElementById("timer");
            counter.innerHTML =
            minutes.toString() + ":" + (seconds < 10 ? "0" : "") + String(seconds);
            seconds--;
            if (seconds >= 0) {
                downloadTimer = setTimeout(tick, 1000);
            } else {
                document.getElementById("otpBtn").disabled = false;
                document.getElementById("timer").innerHTML = "";
            }
        }
        tick();
    };
    $scope.generateCode = function(form){
        delete $scope.messageCodeOTP;
        clearInterval(downloadTimer);
        if(form){
            $scope.progressCircular = true;
            let token =  'bearer '+ decrypt(JSON.parse(window.sessionStorage.getItem('t_agent')));
            let otp = services.otp(token, $scope.username).generate(function(){});
            $q.all([otp.$promise]).then(function(response) {
                console.log(response[0]);
                $scope.progressCircular = false;
                switch(response[0].code) {
                    case -2:
                        $scope.showAlert('Notificación', "El número de documento no se encuentra registrado")
                      break;
                    case 1:
                        document.getElementById("otpBtn").disabled = true;
                        countdown();
                        $scope.messageCodeOTP = "Código OTP enviado al "+response[0].data.to;
                      break;
                    default:
                      // code block
                  }
            }).catch(function(reject) {
                $scope.progressCircular = false;
                $scope.showAlert('Notificación', "Ocurrio un error, comuniquese con soporte técnico")
            });
        }else{
            document.getElementById("phonenumber").focus();
            $scope.errorForm = true;
        }
    };
    function decrypt(data){
        return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
    };
    $scope.set_dial_code = function(data){
        if(data.id === "PHONENUMBER" && $scope.remember && $scope.dial_codes.countries.length === 1 ){
            var styleElem = document.head.appendChild(document.createElement("style"));
            var content = document.head.appendChild(document.createElement("style"));
            styleElem.innerHTML = ".left-addon-user input {padding-left:  60px; }";
            content.innerHTML = '.left-addon-user .fa:after {content: " ' +$scope.dialCode+ ' ";  font-size: 14px; color: #555; font-family: Roboto, "Helvetica Neue", sans-serif;}';
        }
    };
    $scope.$on("progresscircular", function(event, data) {
        $scope.progressCircular = data;
    }); 

    $scope.logoutForce = function (loginFunc) {
        $localStorage.windowStatus = "front"
        var token = $window.localStorage.getItem("access_token1");
        $location.search().identification = ""
        console.log("$scope.logout")
        $window.localStorage.removeItem("access_token1");
        services.logout("bearer " + token).post({}, {}, function (response) {
  
            xmppAuth.Chat.connectionStatus = 0;
            xmppAuth.Chat.disconnect();
            loginFunc()
        });
    };

    function newLogin() {
        var username = $location.search().phoneNumber
        $scope.username = username
        $scope.password = username.slice(-5)
        $scope.progressCircular = true;
        $scope.submit(false, true)   
    }
    
    function otpLogin() {
        isOPTlogin = true 
        $scope.loginWithID = $location.search().loginType === 'ID';
        $scope.docType = "OTP"
        $scope.password = $location.search().otp
        $scope.username = $location.search().username
        $scope.progressCircular = true;
        $scope.submit(false, true)
    }

    if($location.search().phoneNumber && $location.search().prefix && $location.search().newSession) {
        document.getElementById("mainDiv").innerHTML = 'Cargando...'
        $scope.logoutForce(newLogin)        
    }   

    if($location.search().otp) {       
        document.getElementById("mainDiv").innerHTML = 'Cargando...'
        $scope.logoutForce(otpLogin)  
    } else {
        window.sessionStorage.removeItem("documentType");
    }
    if($location.search().identification) {
        $window.sessionStorage.setItem("identification", $location.search().identification)   
        $scope.password = $location.search().password || $location.search().identification.slice(-5)
        $scope.submit(false, true, true)
    }
});

